ACC.unifiedWalletSorting = {
    _autoload: [
        [document.querySelector('#unifiedWalletWrapper, #savedPaymentCards')
        && document.querySelector('#unifiedWalletWrapper, #savedPaymentCards').length !== 0],
    ],

    paypalIndexes: [],

    removeCards: (cardItems, indexes) => cardItems.filter((item, index) => indexes.indexOf(index) === -1),

    // eslint-disable-next-line consistent-return
    sortPreferredPayment: (data, sortParameter) => {
        const cards = data.slice();
        cards.forEach((item, index) => {
            // eslint-disable-next-line no-prototype-builtins
            if (item.hasOwnProperty('preferredPayment') && item.preferredPayment) {
                cards.splice(0, 0, cards.splice(index, 1)[0]);
            }
        });
        cards.forEach((item, index) => {
            // eslint-disable-next-line no-prototype-builtins
            if (item.hasOwnProperty('paymentType') && item.paymentType === 'PayPal') {
                ACC.unifiedWalletSorting.paypalIndexes.push(index);
            }
        });

        // eslint-disable-next-line max-len
        return ACC.unifiedWalletSorting.removeCards(cards, ACC.unifiedWalletSorting.paypalIndexes).slice(0, sortParameter);
    },
};
